import React from 'react';

const DefaultAccountAddPage = React.lazy(() => import('pages/DefaultAccount/DefaultAccountAddPage'));
const DefaultAccountPage = React.lazy(() => import('pages/DefaultAccount/DefaultAccountPage'));

const prefix = '/default-account';
const defaultAccount = [
  {
    path: prefix,
    exact: true,
    name: 'Nguồn khai báo định khoản',
    function: 'AC_DEFAULTACCOUNT_VIEW',
    component: DefaultAccountPage,
  },
  {
    path: `${prefix}/add`,
    exact: true,
    name: 'Thêm cấu hình định khoản',
    function: 'AC_DEFAULTACCOUNT_ADD',
    component: DefaultAccountAddPage,
  },
  {
    path: `${prefix}/edit/:id`,
    exact: true,
    name: 'Chỉnh sửa cấu hình định khoản',
    function: 'AC_DEFAULTACCOUNT_EDIT',
    component: DefaultAccountAddPage,
  },
  {
    path: `${prefix}/detail/:id`,
    exact: true,
    name: 'Chi tiết cấu hình định khoản',
    function: 'AC_DEFAULTACCOUNT_VIEW',
    component: DefaultAccountAddPage,
  },
];

export default defaultAccount;
